import { IndexColumn } from 'components/Table/Columns';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import useAsegurados from 'redux/hooks/emision/useAsegurados';

const Beneficiarios = ({ beneficiarios, ...asegurado }) => {
  const { editarBeneficiarios } = useAsegurados();

  const onClickEliminar = (rowData) => async () => {
    asegurado.beneficiarios = beneficiarios.filter(
      (item) => item.uuid !== rowData.uuid,
    );

    asegurado.estadoIngreso = 'PENDIENTE';
    asegurado.datosCompletos = false;
    await editarBeneficiarios(asegurado);
  };

  return (
    <DataTable
      value={beneficiarios}
      className="p-datatable-gridlines p-datatable-sm mb-3"
      dataKey="id"
      emptyMessage="No se ha ingresado beneficiarios"
      autoLayout
    >
      {IndexColumn()}
      <Column field="rfc" header="RFC" sortable />
      <Column field="nombres" header="Nombres" sortable />
      <Column field="apellidoPaterno" header="Apellido paterno" sortable />
      <Column field="apellidoMaterno" header="Apellido materno" sortable />
      <Column field="parentescoLabel" header="Parentesco" sortable />
      <Column field="porcentaje" header="Porcentaje" sortable />
      <Column field="sexo" header="Sexo" sortable />
      <Column
        header="Opciones"
        body={(rowData) => (
          <Button
            className="p-button-primary p-button-sm btn-block"
            label="Eliminar"
            onClick={onClickEliminar(rowData)}
          />
        )}
      />
    </DataTable>
  );
};

export default Beneficiarios;
